<template>
<div id="app">
  <router-view />
</div>
</template>

<script>
import router from './router'
export default {
  name: 'App',
  beforeCreate() {
    var checkcookie = $cookies.get('arch-asic')
    if (checkcookie == null) {
      //console.log('not login');
      router.push({
        name: 'Login'
      })
    } else {
      //console.log('login');
    }
  },
}
</script>

<style>
@font-face {
  font-family: 'Raleway-swap';
  font-display: swap;
  font-style: normal;
  font-weight: 400;
  src: local('Raleway'), local('Raleway-Regular'), url(https://fonts.gstatic.com/s/raleway/v12/1Ptug8zYS_SKggPNyC0IT4ttDfA.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

body {
  letter-spacing: .3px;
  font-size: 14px;
  font-family: Raleway-swap, sans-serif;
  color: #fff;
}

.logo-home,
.text-copy-home {
  position: absolute;
  background: #fff;
  left: 50%;
  transform: translateX(-50%);
  color: #000;
}

.wrapper-login {
  width: 100%;
  padding: 45px 25px;
  color: #000;
}

.frame {
  border: 5px solid #00205b;
  padding: 25px;
  height: 88vh
}

.logo-home {
  top: 0
}

.logo-home img {
  margin: 15px 25px
}

.all-brands {
  margin-top: 25px
}

h1 {
  color: #00205b;
  font-weight: 700
}

.signin-button {
  margin: 0 auto
}

.text-copy {
  bottom: 10%;
  font-size: 12px
}

.img-login {
  cursor: pointer;
}

@media (max-width:768px) {
  .wrapper {
    width: 100%;
    padding: 35px 25px
  }

  .logo-home .top-logo {
    max-width: 200px !important
  }

  .all-brands {
    padding-left: 0;
    padding-right: 0
  }

  h1 {
    font-size: 19px !important
  }

  .text-copy {
    font-size: 11px
  }
}

.content,
.homemenu,
.login {
  text-align: center
}

.wrapper {
  width: 900px;
  margin: 0 auto
}

.content {
  margin: 25px 0
}

.loginh1 {
  margin-top: 100px;
  margin-bottom: 25px
}

a {
  text-decoration: none
}

a:hover {
  text-decoration: underline
}

.btn-menu,
.btn-menu:hover {
  color: #1e1a33;
  text-decoration: none;
}

.btn-menu img {
  vertical-align: middle;
}


.homemenu {
  margin-top: 20px;
  margin-bottom: 20px
}

.btn-menu,
.footer,
.welcome_txt {
  text-align: left
}

.box-home {
  margin-top: 75px
}

.btn-menu {
  font-weight: 700;
  width: 100%;
  height: 45px;
  padding: 5px;
}

.h10 {
  height: 10px
}

.img_box {
  padding: 20px 10px
}

.img_thumb {
  border: 1px solid #9C9C9C
}

.box-evp,
.box-file-tree {
  padding: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  height: 450px
}

.img_thumb:hover {
  -moz-box-shadow: 0 0 20px #BABABA;
  -webkit-box-shadow: 0 0 20px #BABABA;
  box-shadow: 0 0 20px #BABABA
}

.login {
  margin: 0 auto;
  width: 400px
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  font-size: 11px;
  left: 25px
}

.logo-box {
  margin-top: 5px
}

.logo-box img {
  margin: 0 auto
}

.login-button,
.welcome_txt {
  margin-top: 20px;
  margin-bottom: 20px
}

.welcome_txt {
  font-size: 15px
}

.titleh1,
.titleh2 {
  text-align: center
}

.img_box,
.img_box_home {
  text-align: center;
  margin: 10px
}

.img_box img:hover {
  -webkit-box-shadow: 0 0 3px 2px rgba(255, 255, 255, 1);
  -moz-box-shadow: 0 0 3px 2px rgba(255, 255, 255, 1);
  box-shadow: 0 0 3px 2px rgba(255, 255, 255, 1)
}

.img_box a,
.img_box a:hover,
.img_box_home a,
.img_box_home a:hover {
  color: #fff;
  text-decoration: none
}

.img-responsive {
  margin: 0 auto
}

.box-file-tree {
  width: 100%;
  background: #3e65ff;
  border-radius: 10px
}

.box-evp {
  width: 100%;
  background: #28acaa;
  border-radius: 10px
}

.img_box p {
  background: #1f9601;
  color: #fff;
  padding: 5px 8px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px
}

.titleh1 {
  font-size: 30px;
  color: #fff;
  margin-bottom: 35px;
  margin-top: 35px;
  font-weight: 700
}

.titleh2 {
  font-size: 25px;
  color: #fff;
  margin-bottom: 14px
}

.top-logo {
  margin-top: 25px
}

.text-left {
  text-align: left !important
}

.h1 .small,
.h1 small,
.h2 .small,
.h2 small,
.h3 .small,
.h3 small,
.h4 .small,
.h4 small,
.h5 .small,
.h5 small,
.h6 .small,
.h6 small,
h1 .small,
h1 small,
h2 .small,
h2 small,
h3 .small,
h3 small,
h4 .small,
h4 small,
h5 .small,
h5 small,
h6 .small,
h6 small {
  color: #fff !important
}

.modalinfo {
  color: #000;
}

.modalinfo ul {
  margin-left: 20px;
}

.modalinfo ul li {
  list-style: circle;
}

.modalinfo ul li a {
  color: #000;
}

.modalinfo ul small {
  font-size: 12px;
}

.f12 {
  font-size: 12px
}

.pb25 {
  padding-bottom: 25px
}

.breadcrumb-nav {
  margin-bottom: 15px;
  margin-top: 30px;
  font-size: 13px
}

.button-notif {
  position: fixed;
  bottom: 10px;
  right: 10px;
  background: rgba(47, 51, 56, .9);
  z-index: 90;
  -webkit-border-radius: 360px;
  -moz-border-radius: 360px;
  border-radius: 360px;
  cursor: pointer
}

.i-icon {
  font-size: 20px
}

[data-balloon]:after,
[data-balloon]:before {
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  filter: alpha(opacity=0);
  -khtml-opacity: 0;
  -moz-opacity: 0;
  opacity: 0;
  pointer-events: none;
  -webkit-transition: all .18s ease-out .18s;
  transition: all .18s ease-out .18s;
  bottom: 100%;
  left: 50%;
  position: absolute;
  z-index: 10;
  -webkit-transform: translate(-50%, 10px);
  -ms-transform: translate(-50%, 10px);
  transform: translate(-50%, 10px);
  -webkit-transform-origin: top;
  -ms-transform-origin: top;
  transform-origin: top
}

[data-balloon]:after {
  background: rgba(17, 17, 17, .9);
  border-radius: 4px;
  color: #fff;
  content: attr(data-balloon);
  font-size: 12px;
  padding: .5em 1em;
  white-space: nowrap;
  margin-bottom: 11px
}

[data-balloon]:before {
  background: url(data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba%2817,%2017,%2017,%200.9%29%22%20transform%3D%22rotate%280%29%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E) no-repeat;
  background-size: 100% auto;
  height: 6px;
  width: 18px;
  content: "";
  margin-bottom: 5px
}

[data-balloon]:hover:after,
[data-balloon]:hover:before,
[data-balloon][data-balloon-visible]:after,
[data-balloon][data-balloon-visible]:before {
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
  filter: alpha(opacity=100);
  -khtml-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
  pointer-events: auto;
  -webkit-transform: translate(-50%, 0);
  -ms-transform: translate(-50%, 0);
  transform: translate(-50%, 0)
}

[data-balloon].font-awesome:after {
  font-family: FontAwesome
}

[data-balloon][data-balloon-break]:after {
  white-space: pre
}

[data-balloon-pos=down]:after,
[data-balloon-pos=down]:before {
  bottom: auto;
  left: 50%;
  top: 100%;
  -webkit-transform: translate(-50%, -10px);
  -ms-transform: translate(-50%, -10px);
  transform: translate(-50%, -10px)
}

[data-balloon-pos=down]:after {
  margin-top: 11px
}

[data-balloon-pos=down]:before {
  background: url(data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba%2817,%2017,%2017,%200.9%29%22%20transform%3D%22rotate%28180%2018%206%29%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E) no-repeat;
  background-size: 100% auto;
  height: 6px;
  width: 18px;
  margin-top: 5px;
  margin-bottom: 0
}

[data-balloon-pos=down]:hover:after,
[data-balloon-pos=down]:hover:before,
[data-balloon-pos=down][data-balloon-visible]:after,
[data-balloon-pos=down][data-balloon-visible]:before {
  -webkit-transform: translate(-50%, 0);
  -ms-transform: translate(-50%, 0);
  transform: translate(-50%, 0)
}

[data-balloon-pos=left]:after,
[data-balloon-pos=left]:before {
  bottom: auto;
  left: auto;
  right: 100%;
  top: 50%;
  -webkit-transform: translate(10px, -50%);
  -ms-transform: translate(10px, -50%);
  transform: translate(10px, -50%)
}

[data-balloon-pos=left]:after {
  margin-right: 11px
}

[data-balloon-pos=left]:before {
  background: url(data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2212px%22%20height%3D%2236px%22%3E%3Cpath%20fill%3D%22rgba%2817,%2017,%2017,%200.9%29%22%20transform%3D%22rotate%28-90%2018%2018%29%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E) no-repeat;
  background-size: 100% auto;
  height: 18px;
  width: 6px;
  margin-right: 5px;
  margin-bottom: 0
}

[data-balloon-pos=left]:hover:after,
[data-balloon-pos=left]:hover:before,
[data-balloon-pos=left][data-balloon-visible]:after,
[data-balloon-pos=left][data-balloon-visible]:before,
[data-balloon-pos=right]:hover:after,
[data-balloon-pos=right]:hover:before,
[data-balloon-pos=right][data-balloon-visible]:after,
[data-balloon-pos=right][data-balloon-visible]:before {
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  transform: translate(0, -50%)
}

[data-balloon-pos=right]:after,
[data-balloon-pos=right]:before {
  bottom: auto;
  left: 100%;
  top: 50%;
  -webkit-transform: translate(-10px, -50%);
  -ms-transform: translate(-10px, -50%);
  transform: translate(-10px, -50%)
}

[data-balloon-pos=right]:after {
  margin-left: 11px
}

[data-balloon-pos=right]:before {
  background: url(data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2212px%22%20height%3D%2236px%22%3E%3Cpath%20fill%3D%22rgba%2817,%2017,%2017,%200.9%29%22%20transform%3D%22rotate%2890%206%206%29%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E) no-repeat;
  background-size: 100% auto;
  height: 18px;
  width: 6px;
  margin-bottom: 0;
  margin-left: 5px
}

[data-balloon-length]:after {
  white-space: normal
}

[data-balloon-length=small]:after {
  width: 80px
}

[data-balloon-length=medium]:after {
  width: 150px
}

[data-balloon-length=large]:after {
  width: 260px
}

[data-balloon-length=xlarge]:after {
  width: 90vw
}

@media screen and (min-width:768px) {
  [data-balloon-length=xlarge]:after {
    width: 380px
  }
}

[data-balloon-length=fit]:after {
  width: 100%
}

.modal-body,
.modal-title {
  color: #000
}

@media (max-width:991px) {
  .quick-nav {
    top: 120px;
    margin-top: 0
  }
}

@media (max-width:1366px) {
  .box-home {
    margin-top: 5px !important
  }
}

@media (min-width:1366px) {
  .container {
    width: 1200px;
    /* margin: 0 auto */
  }
}

.bm-menu {
  background: #00205b !important;
}

nav {
  background: none !important;
}

.bm-burger-bars {
  background-color: #fff !important;
}

.bm-item-list {
  font-size: 17px !important;
  margin-left: 0px !important;
}

.bm-item-list>* {
  padding: 0 !important;
  margin-left: 20px;
}

nav,
.sidenav {
  box-shadow: none !important;
}

.breadcrumb-nav a,
.breadcrumb-nav a:hover {
  color: #fff;
  text-decoration: none;
}

.cpointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue